module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('perfect-scrollbar', {
    attrs: {
      "data-mdb-smooth-scroll-init": ""
    }
  }, [_c('div', {
    staticClass: "sidebar-box"
  }, [(_vm.apiType === 'API1') ? _c('div', {
    staticClass: "filter-title"
  }, [_vm._v("Please select service type:")]) : _vm._e(), _vm._v(" "), (_vm.isReturning && _vm.booking.activeLeg === 'leg2' && _vm.apiType === 'API1') ? _c('div', {
    staticClass: "seat-type"
  }, [(_vm.airlinesLeg2.Economy.length || _vm.airlinesLeg2.loading.indexOf('Economy') > -1) ? _c('div', {
    class: ['type-box d-flex', {
      'non-avail': !_vm.airlinesLeg2.filtered.Economy.length && _vm.airlinesLeg2.loading.indexOf('Economy') > -1,
      disabled: !_vm.airlinesLeg2.filtered.Economy.length || _vm.airlinesLeg2.loading.indexOf('Economy') > -1,
      active: _vm.airlinesLeg2.selectedCabin === 'Economy'
    }],
    on: {
      "click": function($event) {
        _vm.changeClass('Economy', 'leg2')
      }
    }
  }, [_c('div', {
    staticClass: "type-desc"
  }, [_c('div', {
    staticClass: "type-name"
  }, [_vm._v("Economy")]), _vm._v(" "), _c('div', {
    staticClass: "flight-count"
  }, [(_vm.airlinesLeg2.loading.indexOf('Economy') > -1) ? _c('span', [(!_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v("\n              Fetching flights...\n            ")]) : _c('span', [_vm._v(_vm._s(_vm.airlinesLeg2.filtered.Economy.length) + " flights found")])])]), _vm._v(" "), _c('div', {
    staticClass: "type-price"
  }, [(!_vm.airlinesLeg2.filtered.Economy.length || _vm.airlinesLeg2.loading.indexOf('Economy') > -1) ? _c('span', {
    staticClass: "empty-na"
  }, [(_vm.airlinesLeg2.loading.indexOf('Economy') > -1 && !_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v(" "), (!_vm.airlinesLeg2.filtered.Economy.length && _vm.airlinesLeg2.loading.indexOf('Economy') === -1) ? _c('b', [_vm._v("N/A")]) : _vm._e()]) : _c('div', [(_vm.currency.code === 'USD') ? _c('b', [_vm._v("$ " + _vm._s(_vm.priceFormat(parseFloat((_vm.airlinesLeg2.filtered.Economy[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]) : _c('b', [_vm._v(_vm._s(_vm.applyCurrency(parseFloat((_vm.airlinesLeg2.filtered.Economy[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]), _vm._v(" "), _c('span', [_vm._v("Starting Price")])])])]) : _vm._e(), _vm._v(" "), (_vm.airlinesLeg2.PremiumEconomy.length || _vm.airlinesLeg2.loading.indexOf('PremiumEconomy') > -1) ? _c('div', {
    class: ['type-box d-flex', {
      'non-avail': !_vm.airlinesLeg2.filtered.PremiumEconomy.length && _vm.airlinesLeg2.loading.indexOf('PremiumEconomy') > -1,
      disabled: !_vm.airlinesLeg2.filtered.PremiumEconomy.length || _vm.airlinesLeg2.loading.indexOf('PremiumEconomy') > -1,
      active: _vm.airlinesLeg2.selectedCabin === 'PremiumEconomy'
    }],
    on: {
      "click": function($event) {
        _vm.changeClass('PremiumEconomy', 'leg2')
      }
    }
  }, [_c('div', {
    staticClass: "type-desc"
  }, [_c('div', {
    staticClass: "type-name"
  }, [_vm._v("Premium Economy")]), _vm._v(" "), _c('div', {
    staticClass: "flight-count"
  }, [(_vm.airlinesLeg2.loading.indexOf('PremiumEconomy') > -1) ? _c('span', [(!_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v("\n              Fetching flights...\n            ")]) : _c('span', [_vm._v(_vm._s(_vm.airlinesLeg2.filtered.PremiumEconomy.length) + " flights found")])])]), _vm._v(" "), _c('div', {
    staticClass: "type-price"
  }, [(!_vm.airlinesLeg2.filtered.PremiumEconomy.length || _vm.airlinesLeg2.loading.indexOf('PremiumEconomy') > -1) ? _c('span', {
    staticClass: "empty-na"
  }, [(_vm.airlinesLeg2.loading.indexOf('PremiumEconomy') > -1 && !_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v(" "), (!_vm.airlinesLeg2.filtered.PremiumEconomy.length && _vm.airlinesLeg2.loading.indexOf('PremiumEconomy') === -1) ? _c('b', [_vm._v("N/A")]) : _vm._e()]) : _c('div', [(_vm.currency.code === 'USD') ? _c('b', [_vm._v("$ " + _vm._s(_vm.priceFormat(parseFloat((_vm.airlinesLeg2.filtered.PremiumEconomy[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]) : _c('b', [_vm._v(_vm._s(_vm.applyCurrency(parseFloat((_vm.airlinesLeg2.filtered.PremiumEconomy[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]), _vm._v(" "), _c('span', [_vm._v("Starting Price")])])])]) : _vm._e(), _vm._v(" "), (_vm.airlinesLeg2.Business.length || _vm.airlinesLeg2.loading.indexOf('Business') > -1) ? _c('div', {
    class: ['type-box d-flex', {
      'non-avail': !_vm.airlinesLeg2.filtered.Business.length && _vm.airlinesLeg2.loading.indexOf('Business') > -1,
      disabled: !_vm.airlinesLeg2.filtered.Business.length || _vm.airlinesLeg2.loading.indexOf('Business') > -1,
      active: _vm.airlinesLeg2.selectedCabin === 'Business'
    }],
    on: {
      "click": function($event) {
        _vm.changeClass('Business', 'leg2')
      }
    }
  }, [_c('div', {
    staticClass: "type-desc"
  }, [_c('div', {
    staticClass: "type-name"
  }, [_vm._v("Business")]), _vm._v(" "), _c('div', {
    staticClass: "flight-count"
  }, [(_vm.airlinesLeg2.loading.indexOf('Business') > -1) ? _c('span', [(!_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v("\n              Fetching flights...\n            ")]) : _c('span', [_vm._v(_vm._s(_vm.airlinesLeg2.filtered.Business.length) + " flights found\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "type-price"
  }, [(!_vm.airlinesLeg2.filtered.Business.length || _vm.airlinesLeg2.loading.indexOf('Business') > -1) ? _c('span', {
    staticClass: "empty-na"
  }, [(_vm.airlinesLeg2.loading.indexOf('Business') > -1 && !_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v(" "), (!_vm.airlinesLeg2.filtered.Business.length && _vm.airlinesLeg2.loading.indexOf('Business') === -1) ? _c('b', [_vm._v("N/A")]) : _vm._e()]) : _c('div', [(_vm.currency.code === 'USD') ? _c('b', [_vm._v("$ " + _vm._s(_vm.priceFormat(parseFloat((_vm.airlinesLeg2.filtered.Business[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]) : _c('b', [_vm._v(_vm._s(_vm.applyCurrency(parseFloat((_vm.airlinesLeg2.filtered.Business[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]), _vm._v(" "), _c('span', [_vm._v("Starting Price")])])])]) : _vm._e(), _vm._v(" "), (_vm.airlinesLeg2.First.length || _vm.airlinesLeg2.loading.indexOf('First') > -1) ? _c('div', {
    class: ['type-box d-flex', {
      'non-avail': !_vm.airlinesLeg2.filtered.First.length && _vm.airlinesLeg2.loading.indexOf('First') > -1,
      disabled: !_vm.airlinesLeg2.filtered.First.length || _vm.airlinesLeg2.loading.indexOf('First') > -1,
      active: _vm.airlinesLeg2.selectedCabin === 'First'
    }],
    on: {
      "click": function($event) {
        _vm.changeClass('First', 'leg2')
      }
    }
  }, [_c('div', {
    staticClass: "type-desc"
  }, [_c('div', {
    staticClass: "type-name"
  }, [_vm._v("First Class")]), _vm._v(" "), _c('div', {
    staticClass: "flight-count"
  }, [(_vm.airlinesLeg2.loading.indexOf('First') > -1) ? _c('span', [(!_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v("\n              Fetching flights...\n            ")]) : _c('span', [_vm._v(_vm._s(_vm.airlinesLeg2.filtered.First.length) + " flights found\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "type-price"
  }, [(!_vm.airlinesLeg2.filtered.First.length || _vm.airlinesLeg2.loading.indexOf('First') > -1) ? _c('span', {
    staticClass: "empty-na"
  }, [(_vm.airlinesLeg2.loading.indexOf('First') > -1 && !_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v(" "), (!_vm.airlinesLeg2.filtered.First.length && _vm.airlinesLeg2.loading.indexOf('First') === -1) ? _c('b', [_vm._v("N/A")]) : _vm._e()]) : _c('div', [(_vm.currency.code === 'USD') ? _c('b', [_vm._v("$ " + _vm._s(_vm.priceFormat(parseFloat((_vm.airlinesLeg2.filtered.First[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]) : _c('b', [_vm._v(_vm._s(_vm.applyCurrency(parseFloat((_vm.airlinesLeg2.filtered.First[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]), _vm._v(" "), _c('span', [_vm._v("Starting Price")])])])]) : _vm._e()]) : (_vm.apiType === 'API1') ? _c('div', {
    staticClass: "seat-type"
  }, [(_vm.airlinesLeg1.Economy.length || _vm.airlinesLeg1.loading.indexOf('Economy') > -1) ? _c('div', {
    class: ['type-box d-flex', {
      'non-avail': !_vm.airlinesLeg1.filtered.Economy.length && _vm.airlinesLeg1.loading.indexOf('Economy') > -1,
      disabled: !_vm.airlinesLeg1.filtered.Economy.length || _vm.airlinesLeg1.loading.indexOf('Economy') > -1,
      active: _vm.airlinesLeg1.selectedCabin === 'Economy'
    }],
    on: {
      "click": function($event) {
        _vm.changeClass('Economy', 'leg1')
      }
    }
  }, [_c('div', {
    staticClass: "type-desc"
  }, [_c('div', {
    staticClass: "type-name"
  }, [_vm._v("Economy")]), _vm._v(" "), _c('div', {
    staticClass: "flight-count"
  }, [(_vm.airlinesLeg1.loading.indexOf('Economy') > -1) ? _c('span', [(!_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v("\n              Fetching flights...\n            ")]) : _c('span', [_vm._v(_vm._s(_vm.airlinesLeg1.filtered.Economy.length) + " flights found\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "type-price"
  }, [(!_vm.airlinesLeg1.filtered.Economy.length || _vm.airlinesLeg1.loading.indexOf('Economy') > -1) ? _c('span', {
    staticClass: "empty-na"
  }, [(_vm.airlinesLeg1.loading.indexOf('Economy') > -1 && !_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v(" "), (!_vm.airlinesLeg1.filtered.Economy.length && _vm.airlinesLeg1.loading.indexOf('Economy') === -1) ? _c('b', [_vm._v("N/A")]) : _vm._e()]) : _c('div', [(_vm.currency.code === 'USD') ? _c('b', [_vm._v("$ " + _vm._s(_vm.priceFormat(parseFloat((_vm.airlinesLeg1.filtered.Economy[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]) : _c('b', [_vm._v(_vm._s(_vm.applyCurrency(parseFloat((_vm.airlinesLeg1.filtered.Economy[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]), _vm._v(" "), _c('span', [_vm._v("Starting Price")])])])]) : _vm._e(), _vm._v(" "), (_vm.airlinesLeg1.PremiumEconomy.length || _vm.airlinesLeg1.loading.indexOf('PremiumEconomy') > -1) ? _c('div', {
    class: ['type-box d-flex', {
      'non-avail': !_vm.airlinesLeg1.filtered.PremiumEconomy.length && _vm.airlinesLeg1.loading.indexOf('PremiumEconomy') > -1,
      disabled: !_vm.airlinesLeg1.filtered.PremiumEconomy.length || _vm.airlinesLeg1.loading.indexOf('PremiumEconomy') > -1,
      active: _vm.airlinesLeg1.selectedCabin === 'PremiumEconomy'
    }],
    on: {
      "click": function($event) {
        _vm.changeClass('PremiumEconomy', 'leg1')
      }
    }
  }, [_c('div', {
    staticClass: "type-desc"
  }, [_c('div', {
    staticClass: "type-name"
  }, [_vm._v("Premium Economy")]), _vm._v(" "), _c('div', {
    staticClass: "flight-count"
  }, [(_vm.airlinesLeg1.loading.indexOf('PremiumEconomy') > -1) ? _c('span', [(!_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v("\n              Fetching flights...\n            ")]) : _c('span', [_vm._v(_vm._s(_vm.airlinesLeg1.filtered.PremiumEconomy.length) + " flights found\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "type-price"
  }, [(!_vm.airlinesLeg1.filtered.PremiumEconomy.length || _vm.airlinesLeg1.loading.indexOf('PremiumEconomy') > -1) ? _c('span', {
    staticClass: "empty-na"
  }, [(_vm.airlinesLeg1.loading.indexOf('PremiumEconomy') > -1 && !_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v(" "), (!_vm.airlinesLeg1.filtered.PremiumEconomy.length && _vm.airlinesLeg1.loading.indexOf('PremiumEconomy') === -1) ? _c('b', [_vm._v("N/A")]) : _vm._e()]) : _c('div', [(_vm.currency.code === 'USD') ? _c('b', [_vm._v("$ " + _vm._s(_vm.priceFormat(parseFloat((_vm.airlinesLeg1.filtered.PremiumEconomy[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]) : _c('b', [_vm._v(_vm._s(_vm.applyCurrency(parseFloat((_vm.airlinesLeg1.filtered.PremiumEconomy[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]), _vm._v(" "), _c('span', [_vm._v("Starting Price")])])])]) : _vm._e(), _vm._v(" "), (_vm.airlinesLeg1.Business.length || _vm.airlinesLeg1.loading.indexOf('Business') > -1) ? _c('div', {
    class: ['type-box d-flex', {
      'non-avail': !_vm.airlinesLeg1.filtered.Business.length && _vm.airlinesLeg1.loading.indexOf('Business') > -1,
      disabled: !_vm.airlinesLeg1.filtered.Business.length || _vm.airlinesLeg1.loading.indexOf('Business') > -1,
      active: _vm.airlinesLeg1.selectedCabin === 'Business'
    }],
    on: {
      "click": function($event) {
        _vm.changeClass('Business', 'leg1')
      }
    }
  }, [_c('div', {
    staticClass: "type-desc"
  }, [_c('div', {
    staticClass: "type-name"
  }, [_vm._v("Business")]), _vm._v(" "), _c('div', {
    staticClass: "flight-count"
  }, [(_vm.airlinesLeg1.loading.indexOf('Business') > -1) ? _c('span', [(!_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v("\n              Fetching flights...\n            ")]) : _c('span', [_vm._v(_vm._s(_vm.airlinesLeg1.filtered.Business.length) + " flights found")])])]), _vm._v(" "), _c('div', {
    staticClass: "type-price"
  }, [(!_vm.airlinesLeg1.filtered.Business.length || _vm.airlinesLeg1.loading.indexOf('Business') > -1) ? _c('span', {
    staticClass: "empty-na"
  }, [(_vm.airlinesLeg1.loading.indexOf('Business') > -1 && !_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v(" "), (!_vm.airlinesLeg1.filtered.Business.length && _vm.airlinesLeg1.loading.indexOf('Business') === -1) ? _c('b', [_vm._v("N/A")]) : _vm._e()]) : _c('div', [(_vm.currency.code === 'USD') ? _c('b', [_vm._v("$ " + _vm._s(_vm.priceFormat(parseFloat((_vm.airlinesLeg1.filtered.Business[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]) : _c('b', [_vm._v(_vm._s(_vm.applyCurrency(parseFloat((_vm.airlinesLeg1.filtered.Business[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]), _vm._v(" "), _c('span', [_vm._v("Starting Price")])])])]) : _vm._e(), _vm._v(" "), (_vm.airlinesLeg1.First.length || _vm.airlinesLeg1.loading.indexOf('First') > -1) ? _c('div', {
    class: ['type-box d-flex', {
      'non-avail': !_vm.airlinesLeg1.filtered.First.length && _vm.airlinesLeg1.loading.indexOf('First') > -1,
      disabled: !_vm.airlinesLeg1.filtered.First.length || _vm.airlinesLeg1.loading.indexOf('First') > -1,
      active: _vm.airlinesLeg1.selectedCabin === 'First'
    }],
    on: {
      "click": function($event) {
        _vm.changeClass('First', 'leg1')
      }
    }
  }, [_c('div', {
    staticClass: "type-desc"
  }, [_c('div', {
    staticClass: "type-name"
  }, [_vm._v("First Class")]), _vm._v(" "), _c('div', {
    staticClass: "flight-count"
  }, [(_vm.airlinesLeg1.loading.indexOf('First') > -1) ? _c('span', [(!_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v("\n              Fetching flights...\n            ")]) : _c('span', [_vm._v(_vm._s(_vm.airlinesLeg1.filtered.First.length) + " flights found")])])]), _vm._v(" "), _c('div', {
    staticClass: "type-price"
  }, [(!_vm.airlinesLeg1.filtered.First.length || _vm.airlinesLeg1.loading.indexOf('First') > -1) ? _c('span', {
    staticClass: "empty-na"
  }, [(_vm.airlinesLeg1.loading.indexOf('First') > -1 && !_vm.appLoader) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v(" "), (!_vm.airlinesLeg1.filtered.First.length && _vm.airlinesLeg1.loading.indexOf('First') === -1) ? _c('b', [_vm._v("N/A")]) : _vm._e()]) : _c('div', [(_vm.currency.code === 'USD') ? _c('b', [_vm._v("$ " + _vm._s(_vm.priceFormat(parseFloat((_vm.airlinesLeg1.filtered.First[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]) : _c('b', [_vm._v(_vm._s(_vm.applyCurrency(parseFloat((_vm.airlinesLeg1.filtered.First[0].payment.totalWithMarkUp + _vm.otherLegPrice()).toFixed(2)))))]), _vm._v(" "), _c('span', [_vm._v("Starting Price")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.apiType === 'API1') ? _c('hr', {
    staticClass: "show-on-mobile"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "show-on-mobile sb-sort"
  }, [_c('label', [_vm._v("Sort by")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.sort),
      expression: "filters.sort"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filters.sort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "price-low-to-high"
    }
  }, [_vm._v("Price: low to high")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "price-high-to-low"
    }
  }, [_vm._v("Price: high to low")])])]), _vm._v(" "), (_vm.apiType === 'API1') ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-title"
  }, [_vm._v("Airlines")]), _vm._v(" "), _c('perfect-scrollbar', {
    staticClass: "airline-scroll",
    attrs: {
      "data-mdb-smooth-scroll-init": ""
    }
  }, [_c('ul', {
    staticClass: "airline-list"
  }, [_vm._l((_vm.airlinesLeg1.unique.API2), function(airline, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.airlinesLeg1.selectedCabin === 'API2' && _vm.booking.activeLeg === 'leg1'),
        expression: "airlinesLeg1.selectedCabin === 'API2' && booking.activeLeg === 'leg1'"
      }],
      key: ("leg1" + i),
      class: {
        active: _vm.filters.airlines.leg1.indexOf(airline.name) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleAirline(airline.name)
        }
      }
    }, [_c('div', {
      staticClass: "d-flex al-name"
    }, [_c('img', {
      attrs: {
        "src": airline.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(airline.name))])]), _vm._v(" "), _c('div', {
      staticClass: "al-price"
    }, [(_vm.currency.code === 'USD') ? _c('span', [_vm._v("$ " + _vm._s(parseFloat(airline.price + _vm.lowestAirlinePriceLeg2(airline.name)).toFixed(2)))]) : (_vm.currency.code !== 'USD') ? _c('span', [_vm._v(_vm._s(_vm.applyCurrency(airline.price + _vm.lowestAirlinePriceLeg2(airline.name))))]) : _vm._e()])])
  }), _vm._v(" "), _vm._l((_vm.airlinesLeg1.unique.Economy), function(airline, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.airlinesLeg1.selectedCabin === 'Economy' && _vm.booking.activeLeg === 'leg1'),
        expression: "airlinesLeg1.selectedCabin === 'Economy' && booking.activeLeg === 'leg1'"
      }],
      key: ("leg1" + i),
      class: {
        active: _vm.filters.airlines.leg1.indexOf(airline.name) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleAirline(airline.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": airline.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(airline.name))])])
  }), _vm._v(" "), _vm._l((_vm.airlinesLeg1.unique.PremiumEconomy), function(airline, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.airlinesLeg1.selectedCabin === 'PremiumEconomy' && _vm.booking.activeLeg === 'leg1'),
        expression: "airlinesLeg1.selectedCabin === 'PremiumEconomy' && booking.activeLeg === 'leg1'"
      }],
      key: ("leg1" + i),
      class: {
        active: _vm.filters.airlines.leg1.indexOf(airline.name) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleAirline(airline.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": airline.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(airline.name))])])
  }), _vm._v(" "), _vm._l((_vm.airlinesLeg1.unique.Business), function(airline, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.airlinesLeg1.selectedCabin === 'Business' && _vm.booking.activeLeg === 'leg1'),
        expression: "airlinesLeg1.selectedCabin === 'Business' && booking.activeLeg === 'leg1'"
      }],
      key: ("leg1" + i),
      class: {
        active: _vm.filters.airlines.leg1.indexOf(airline.name) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleAirline(airline.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": airline.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(airline.name))])])
  }), _vm._v(" "), _vm._l((_vm.airlinesLeg1.unique.PremiumBusiness), function(airline, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.airlinesLeg1.selectedCabin === 'PremiumBusiness' && _vm.booking.activeLeg === 'leg1'),
        expression: "airlinesLeg1.selectedCabin === 'PremiumBusiness' && booking.activeLeg === 'leg1'"
      }],
      key: ("leg1" + i),
      class: {
        active: _vm.filters.airlines.leg1.indexOf(airline.name) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleAirline(airline.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": airline.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(airline.name))])])
  }), _vm._v(" "), _vm._l((_vm.airlinesLeg1.unique.First), function(airline, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.airlinesLeg1.selectedCabin === 'First' && _vm.booking.activeLeg === 'leg1'),
        expression: "airlinesLeg1.selectedCabin === 'First' && booking.activeLeg === 'leg1'"
      }],
      key: ("leg1" + i),
      class: {
        active: _vm.filters.airlines.leg1.indexOf(airline.name) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleAirline(airline.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": airline.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(airline.name))])])
  }), _vm._v(" "), _vm._l((_vm.airlinesLeg2.unique.API2), function(airline, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.airlinesLeg2.selectedCabin === 'API2' && _vm.booking.activeLeg === 'leg2'),
        expression: "airlinesLeg2.selectedCabin === 'API2' && booking.activeLeg === 'leg2'"
      }],
      key: ("leg2" + i),
      class: {
        active: _vm.filters.airlines.leg2.indexOf(airline.name) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleAirline(airline.name)
        }
      }
    }, [_c('div', [_c('img', {
      attrs: {
        "src": airline.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(airline.name))])]), _vm._v(" "), _c('div', [(_vm.currency.code === 'USD') ? _c('span', [_vm._v("$ " + _vm._s(parseFloat(airline.price - _vm.lowestAirlinePriceLeg2(airline.name)).toFixed(2)))]) : (_vm.currency.code !== 'USD') ? _c('span', [_vm._v(_vm._s(_vm.applyCurrency(airline.price - _vm.lowestAirlinePriceLeg2(airline.name))))]) : _vm._e()])])
  }), _vm._v(" "), _vm._l((_vm.airlinesLeg2.unique.Economy), function(airline, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.airlinesLeg2.selectedCabin === 'Economy' && _vm.booking.activeLeg === 'leg2'),
        expression: "airlinesLeg2.selectedCabin === 'Economy' && booking.activeLeg === 'leg2'"
      }],
      key: ("leg2" + i),
      class: {
        active: _vm.filters.airlines.leg2.indexOf(airline.name) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleAirline(airline.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": airline.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(airline.name))])])
  }), _vm._v(" "), _vm._l((_vm.airlinesLeg2.unique.PremiumEconomy), function(airline, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.airlinesLeg2.selectedCabin === 'PremiumEconomy' && _vm.booking.activeLeg === 'leg2'),
        expression: "airlinesLeg2.selectedCabin === 'PremiumEconomy' && booking.activeLeg === 'leg2'"
      }],
      key: ("leg2" + i),
      class: {
        active: _vm.filters.airlines.leg2.indexOf(airline.name) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleAirline(airline.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": airline.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(airline.name))])])
  }), _vm._v(" "), _vm._l((_vm.airlinesLeg2.unique.Business), function(airline, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.airlinesLeg2.selectedCabin === 'Business' && _vm.booking.activeLeg === 'leg2'),
        expression: "airlinesLeg2.selectedCabin === 'Business' && booking.activeLeg === 'leg2'"
      }],
      key: ("leg2" + i),
      class: {
        active: _vm.filters.airlines.leg2.indexOf(airline.name) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleAirline(airline.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": airline.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(airline.name))])])
  }), _vm._v(" "), _vm._l((_vm.airlinesLeg2.unique.PremiumBusiness), function(airline, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.airlinesLeg2.selectedCabin === 'PremiumBusiness' && _vm.booking.activeLeg === 'leg2'),
        expression: "airlinesLeg2.selectedCabin === 'PremiumBusiness' && booking.activeLeg === 'leg2'"
      }],
      key: ("leg2" + i),
      class: {
        active: _vm.filters.airlines.leg2.indexOf(airline.name) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleAirline(airline.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": airline.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(airline.name))])])
  }), _vm._v(" "), _vm._l((_vm.airlinesLeg2.unique.First), function(airline, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.airlinesLeg2.selectedCabin === 'First' && _vm.booking.activeLeg === 'leg2'),
        expression: "airlinesLeg2.selectedCabin === 'First' && booking.activeLeg === 'leg2'"
      }],
      key: ("leg2" + i),
      class: {
        active: _vm.filters.airlines.leg2.indexOf(airline.name) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleAirline(airline.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": airline.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(airline.name))])])
  })], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "filter-title"
  }, [_vm._v("Flight Stops")]), _vm._v(" "), _c('ul', {
    staticClass: "time-list"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.toggleStop(0)
      }
    }
  }, [(_vm.isReturning && _vm.booking.activeLeg === 'leg2') ? _c('div', [(_vm.flightStopReturn.indexOf(0) > -1) ? _c('i', {
    staticClass: "fas fa-check-square fa-fw"
  }) : _c('i', {
    staticClass: "far fa-square fa-fw"
  }), _vm._v("\n          Nonstop Flight\n        ")]) : _c('div', [(_vm.flightStop.indexOf(0) > -1) ? _c('i', {
    staticClass: "fas fa-check-square fa-fw"
  }) : _c('i', {
    staticClass: "far fa-square fa-fw"
  }), _vm._v("\n          Nonstop Flight\n        ")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleStop(1)
      }
    }
  }, [(_vm.isReturning && _vm.booking.activeLeg === 'leg2') ? _c('div', [(_vm.flightStopReturn.indexOf(1) > -1) ? _c('i', {
    staticClass: "fas fa-check-square fa-fw"
  }) : _c('i', {
    staticClass: "far fa-square fa-fw"
  }), _vm._v("\n          1 Stop\n        ")]) : _c('div', [(_vm.flightStop.indexOf(1) > -1) ? _c('i', {
    staticClass: "fas fa-check-square fa-fw"
  }) : _c('i', {
    staticClass: "far fa-square fa-fw"
  }), _vm._v("\n          1 Stop\n        ")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleStop(2)
      }
    }
  }, [(_vm.isReturning && _vm.booking.activeLeg === 'leg2') ? _c('div', [(_vm.flightStopReturn.indexOf(2) > -1) ? _c('i', {
    staticClass: "fas fa-check-square fa-fw"
  }) : _c('i', {
    staticClass: "far fa-square fa-fw"
  }), _vm._v("\n          2 Stops\n        ")]) : _c('div', [(_vm.flightStop.indexOf(2) > -1) ? _c('i', {
    staticClass: "fas fa-check-square fa-fw"
  }) : _c('i', {
    staticClass: "far fa-square fa-fw"
  }), _vm._v("\n          2 Stops\n        ")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleStop(3)
      }
    }
  }, [(_vm.isReturning && _vm.booking.activeLeg === 'leg2') ? _c('div', [(_vm.flightStopReturn.indexOf(3) > -1) ? _c('i', {
    staticClass: "fas fa-check-square fa-fw"
  }) : _c('i', {
    staticClass: "far fa-square fa-fw"
  }), _vm._v("\n          3 Stops\n        ")]) : _c('div', [(_vm.flightStop.indexOf(3) > -1 && _vm.airlinesReturn.active === 'leg1') ? _c('i', {
    staticClass: "fas fa-check-square fa-fw"
  }) : _c('i', {
    staticClass: "far fa-square fa-fw"
  }), _vm._v("\n          3 Stops\n        ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.booking.activeLeg === 'leg1') ? _c('div', [_c('div', {
    staticClass: "filter-title"
  }, [_vm._v("Departure Time "), (_vm.isReturning) ? _c('span', [_vm._v("(First Flight)")]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "time-list"
  }, _vm._l((_vm.timeOptions), function(time, i) {
    return _c('li', {
      key: i,
      on: {
        "click": function($event) {
          _vm.toggleTime('departure', time.key)
        }
      }
    }, [_c('div', [(_vm.departure[time.key]) ? _c('i', {
      staticClass: "fas fa-check-square fa-fw"
    }) : _c('i', {
      staticClass: "far fa-square fa-fw"
    }), _vm._v("\n            " + _vm._s(time.label1) + "\n          ")]), _vm._v(" "), _c('span', {
      staticClass: "time-val"
    }, [_vm._v(_vm._s(time.label2))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "filter-title"
  }, [_vm._v("Arrival Time "), (_vm.isReturning) ? _c('span', [_vm._v("(First Flight)")]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "time-list"
  }, _vm._l((_vm.timeOptions), function(time, i) {
    return _c('li', {
      key: i,
      on: {
        "click": function($event) {
          _vm.toggleTime('arrival', time.key)
        }
      }
    }, [_c('div', [(_vm.arrival[time.key]) ? _c('i', {
      staticClass: "fas fa-check-square fa-fw"
    }) : _c('i', {
      staticClass: "far fa-square fa-fw"
    }), _vm._v("\n            " + _vm._s(time.label1) + "\n          ")]), _vm._v(" "), _c('span', {
      staticClass: "time-val"
    }, [_vm._v(_vm._s(time.label2))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isReturning && (_vm.booking.activeLeg === 'leg2' || !_vm.isCustomFlight)) ? _c('div', [_c('div', {
    staticClass: "filter-title"
  }, [_vm._v("Departure Time "), _c('span', [_vm._v("(Return Flight)")])]), _vm._v(" "), _c('ul', {
    staticClass: "time-list"
  }, _vm._l((_vm.timeOptions), function(time, i) {
    return _c('li', {
      key: i,
      on: {
        "click": function($event) {
          _vm.toggleTime('departureReturn', time.key)
        }
      }
    }, [_c('div', [(_vm.departureReturn[time.key]) ? _c('i', {
      staticClass: "fas fa-check-square fa-fw"
    }) : _c('i', {
      staticClass: "far fa-square fa-fw"
    }), _vm._v("\n            " + _vm._s(time.label1) + "\n          ")]), _vm._v(" "), _c('span', {
      staticClass: "time-val"
    }, [_vm._v(_vm._s(time.label2))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "filter-title"
  }, [_vm._v("Arrival Time "), _c('span', [_vm._v("(Return Flight)")])]), _vm._v(" "), _c('ul', {
    staticClass: "time-list"
  }, _vm._l((_vm.timeOptions), function(time, i) {
    return _c('li', {
      key: i,
      on: {
        "click": function($event) {
          _vm.toggleTime('arrivalReturn', time.key)
        }
      }
    }, [_c('div', [(_vm.arrivalReturn[time.key]) ? _c('i', {
      staticClass: "fas fa-check-square fa-fw"
    }) : _c('i', {
      staticClass: "far fa-square fa-fw"
    }), _vm._v("\n            " + _vm._s(time.label1) + "\n          ")]), _vm._v(" "), _c('span', {
      staticClass: "time-val"
    }, [_vm._v(_vm._s(time.label2))])])
  }))]) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ecd749c6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecd749c6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DService/Sidebar.vue
// module id = 2150
// module chunks = 0